import React from "react";

export interface DineoutSharedCartContextValue {
    userIntent: boolean;
    setUserIntent: (val: boolean) => void;
    maxPoolAmountAllowed: number;
    maxNoOfContributorsAllowed: number;
    maxPerPersonCap: number;
    poolType: string;
    cartId: string;
    lastKnownUpdatedAt: string | null;
    setLastKnownUpdatedAt: (val: string | null) => void;
    returnedFromPoolPage: boolean;
    setReturnedFromPoolPage: (val: boolean) => void;
    contributionsArrivedOnPoolPage: boolean;
    setContributionsArrivedOnPoolPage: (val: boolean) => void;
}

export const DineoutSharedCartContext = React.createContext<DineoutSharedCartContextValue>({
    userIntent: false,
    setUserIntent: () => void 0,
    maxPoolAmountAllowed: 0,
    maxNoOfContributorsAllowed: 0,
    maxPerPersonCap: 0,
    poolType: "",
    cartId: "",
    lastKnownUpdatedAt: null,
    setLastKnownUpdatedAt: () => void 0,
    returnedFromPoolPage: false,
    setReturnedFromPoolPage: () => void 0,
    contributionsArrivedOnPoolPage: false,
    setContributionsArrivedOnPoolPage: () => void 0,
});
